(() => {
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const url = new URL(location.href);
    if (root.dataset.catalog !== 'true' && root.dataset.defaultAvailable === 'true' && !url.searchParams.has('filter.v.availability') && url.searchParams.get('od_show') !== 'all' && !window.Shopify?.designMode) {
      url.searchParams.set('filter.v.availability', '1');
      url.searchParams.delete('page');
      location.replace(url.href);
      return;
    }
    const dialog = root.querySelector('dialog');
    const opener = root.querySelector('[data-filter-open]');
    const form = root.querySelector('[data-filter-form]');
    const available = root.querySelector('[data-availability]');
    available.disabled = root.dataset.availableActive !== 'true' && url.searchParams.get('filter.v.availability') !== '1';
    root.classList.add('is-enhanced');
    root.querySelectorAll('[data-collection-view]').forEach(link => {
      const destination = new URL(location.href);
      destination.searchParams.delete('page');
      if (root.dataset.catalog === 'true') destination.pathname = link.dataset.collectionView === 'all' ? '/collections/all-pieces' : '/collections/all';
      destination.searchParams.set('od_show', 'all');
      if (link.dataset.collectionView === 'available') destination.searchParams.set('filter.v.availability', '1');
      else destination.searchParams.delete('filter.v.availability');
      link.href = destination.href;
      const active = link.dataset.collectionView === (available.disabled ? 'all' : 'available');
      if (active) link.setAttribute('aria-current','page'); else link.removeAttribute('aria-current');
    });
    const showAll = document.createElement('input');
    showAll.type = 'hidden'; showAll.name = 'od_show'; showAll.value = 'all';
    form.append(showAll);
    for (const key of ['preview_theme_id', '_fd', 'pb']) {
      if (url.searchParams.has(key)) {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = key; input.value = url.searchParams.get(key); form.append(input);
      }
    }
    opener.addEventListener('click', () => dialog.showModal());
    root.querySelector('[data-filter-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right) dialog.close();
      }
    });
    dialog.addEventListener('close', () => opener.focus());
    form.addEventListener('submit', () => form.querySelectorAll('input[type=number]').forEach(input => { if (!input.value) input.disabled = true; }));
    root.querySelectorAll('.odc-pagination a, .odc-active-filters a, [data-load-more]').forEach(link => {
      const destination = new URL(link.href, location.origin);
      destination.searchParams.set('od_show', 'all');
      link.href = destination.href;
    });
    const initializePhotos = () => {};
    initializePhotos();
    const more = root.querySelector('[data-load-more]');
    if (more) more.addEventListener('click', async event => {
      if (!matchMedia('(max-width: 989px)').matches) return;
      event.preventDefault();
      if (more.getAttribute('aria-disabled') === 'true') return;
      const destination = more.href;
      more.setAttribute('aria-disabled','true');
      more.textContent = root.dataset.loadingLabel;
      try {
        const response = await fetch(destination, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Collection request failed');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const nextRoot = doc.querySelector('[data-od-collection]');
        const cards = nextRoot?.querySelectorAll('.odc-grid > .odc-card');
        if (!cards?.length) throw new Error('No collection cards');
        cards.forEach(card => root.querySelector('.odc-grid').append(document.importNode(card,true)));
        initializePhotos();
        const count = nextRoot.querySelector('[data-collection-count]');
        if (count) {
          root.querySelector('[data-collection-count]').textContent = count.textContent;
          root.querySelector('[data-load-status]').textContent = count.textContent;
        }
        const next = nextRoot.querySelector('[data-load-more]');
        if (next) {
          const nextUrl = new URL(next.getAttribute('href'),destination);
          nextUrl.searchParams.set('od_show','all');
          more.href = nextUrl.href;
        } else more.hidden = true;
      } catch { location.assign(destination); }
      finally {more.removeAttribute('aria-disabled');more.textContent=root.dataset.loadLabel;}
    });
  };
  document.querySelectorAll('[data-od-collection]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-od-collection]').forEach(initialize));
})();

